import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { Pages, Roles } from '../../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../../../routings/helpers/LogicalRoute';
import { AccessAnalysisBlockPage } from '../screens/blockPage';
import { AccessAnalysisActiveDirectoryRoutes } from './AccessAnalysisActiveDirectoryRoutes';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const AccessAnalysisRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();

    const displayBlockPage = isPageBlocked(LAYOUT_TABS.ACCESS_ANALYSIS.ID);
    const disabled = !useHasPermissions({ permission: Pages.ACCESS_ANALYSIS, role: Roles.VIEWER });

    return (
        <LogicalRoute
            component={AccessAnalysisActiveDirectoryRoutes}
            blockPageComponent={AccessAnalysisBlockPage}
            disabled={disabled}
            displayBlockPage={displayBlockPage}
            path={props.path}
        />
    );
};
